import { render, staticRenderFns } from "./QuestionMultidimensionalTable.vue?vue&type=template&id=5f33a566&scoped=true&"
import script from "./QuestionMultidimensionalTable.vue?vue&type=script&lang=js&"
export * from "./QuestionMultidimensionalTable.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMultidimensionalTable.vue?vue&type=style&index=0&id=5f33a566&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f33a566",
  null
  
)

export default component.exports